import React, { FC } from "react";
import styles from "./card.module.css";

type CardProps = {
  title: string;
  text: string;
  type?: "default" | "primary";
  className?: string;
};

export const Card: FC<CardProps> = ({
  title,
  text,
  type = "default",
  className,
}) => {
  return (
    <div className={`${styles.card} ${styles[type]} ${className}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};
